let datesMixin = {
    data() {
        return {
            _startRequrst: false,
            abortController: null
        }
    },

    computed: {
        date_from() {
            return this.$store.getters.filterDateFrom
        },
        date_to() {
            return this.$store.getters.filterDateTo
        }
    },
    watch: {
        date_from() {
            this.startRequest();
        },
        date_to() {
            this.startRequest();
        },
    },
    methods: {
        startRequest() {

            if (this._startRequrst) {
                this.abortController.abort();
            }
            this.abortController = new AbortController();
            this._startRequrst = true;
            this.getData({signal: this.abortController.signal})

        }
    }

};
export default datesMixin;
